import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ErrorTicketGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var ticketGrid = this;
		setTimeout(function(){
			ticketGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var ticketGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterErrorId',
					label: 'Error Id',
					name: 'errorTicketId',
					listeners: {
						input: {
							fn: function(e) {
								actionRefresh();
							},
							buffer: 1000
						}
					}
				},				
				{
					tag: 'vaadin-button',
					itemid: 'view',
					theme: 'primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},													
				{
					tag: 'vaadin-button',
					itemid: 'delete',
					theme: 'error primary',					
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 37px;',
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{	
					path: 'errorTicketId',
					header: 'Error Id',					
					width: '7em'
				},	
				{	
					path: 'updateDts',
					header: 'Ticket Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{	
					path: 'errorTypeCode',
					header: 'Error Type',					
					width: '5em',
					'text-align': 'center'
				},				
				{
					path: 'message',
					header: 'Message',
					'flex-grow': '1'
					
				},
				{
					path: 'potentialResolution',
					header: 'Description',						
					width: '9em'
				},
				{
					path: 'clientIp',
					header: 'Client Ip',					
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'view').disabled = false; 						
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;						
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}				
			}
		});	
		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					ticketGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
						sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
						filterField: 'errorTicketId',
						filterValue: ElementUtil.query(toolbar, 'filterErrorId').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						ticketGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getErrorTicketService().getTickets(ticketGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		ticketGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};

		var actionExport = function() {
			var exportFilter = Object.assign({}, ticketGrid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			Service.getErrorTicketService().exportTickets(exportFilter);
		};
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Message',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
						
							var detailData = [
								{
									key: 'Update Date',
									value: TimeUtil.formatDateStandard(TimeUtil.parseDate(inputRecord.updateDts))
								},								
								{
									key: 'Error Ticket Id',
									value: inputRecord.errorTicketId
								},
								{
									key: 'Error Type Code',
									value: inputRecord.errorTypeCode
								},
								{
									key: 'Client IP',
									value: inputRecord.clientIp
								},
								{
									key: 'Called Action',
									value: inputRecord.calledAction
								},
								{
									key: 'Message',
									value: inputRecord.message ? inputRecord.message : ''
								},
								{
									key: 'Potential Resolution',
									value: inputRecord.potentialResolution ? inputRecord.potentialResolution : ''
								},
								{
									key: 'Detail',
									value: inputRecord.details
								}								
							];
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',									
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(ticketGrid.fullDataSet);
											event.target.setSelectedRecord('errorTicketId', record.errorTicketId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));						
						
					}
				}
			});
		
						
		};

		
		var actionDelete = function(record) {			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + TimeUtil.formatDateStandard(TimeUtil.parseDate(record.updateDts)) + ' ticket(s)?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							var ids = [];
							ids.push(record.errorTicketId);
							
							Service.getErrorTicketService().deleteTickets(ids).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted selected ticket.', {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};
		

	}
	
};
customElements.define('dl-errorticket-grid', ErrorTicketGrid);